/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import Bootstrap
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import Amplify, set up config
import Amplify, * as AmplifyModules from 'aws-amplify'
import {
  AmplifyPlugin
} from 'aws-amplify-vue'


const awsmobile = {
  "aws_project_region": process.env.VUE_APP_COGNITO_REGION,
  "aws_cognito_identity_pool_id": process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID,
  "aws_cognito_region": process.env.VUE_APP_COGNITO_REGION,
  "aws_user_pools_id": process.env.VUE_APP_USER_POOLS_ID,
  "aws_user_pools_web_client_id": process.env.VUE_APP_USER_POOLS_WEB_CLIENT_ID,
  "oauth": {}
};

Amplify.configure(awsmobile)

Vue.use(AmplifyPlugin, AmplifyModules)

Vue.use(BootstrapVue)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')